import React from "react";

interface ErrorNotificationProps {
    error: string | null;
}

export const ErrorNotification: React.FC<ErrorNotificationProps> = ({
    error
}) => {
    if (!error) return null;

    return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 sm:px-4 sm:py-3 rounded mb-4">
            {error}
        </div>
    );
};
